module.exports = "<div class=\"stay-mgmt theme-ihg\">\n   <router-outlet></router-outlet>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/app.component.html
// module id = ./src/main/webapp/stay-mgmt/app/app.component.html
// module chunks = 0